import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🙋", key: "justMe" },
  { emoji: "👨‍👩‍👧‍👦", key: "family" },
  { emoji: "🧑‍🤝‍🧑", key: "team" },
  { emoji: "🤝", key: "buyersOrMechanics" },
]

export default function CarsShareWithWhoPage() {
  return (
    <RadioCardListPage translationKey="carsShareWithWho" options={OPTIONS} />
  )
}
